// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Leibniz from "../Data.Leibniz/index.js";
import * as Data_Loading from "../Data.Loading/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Form_Checkbox from "../Restaumatic.Form.Checkbox/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_EditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_HasDefaultValue from "../Restaumatic.Form.HasDefaultValue/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Value.applicativeValue);
var getContext = /* #__PURE__ */ Restaumatic_Form_Internal.getContext(Restaumatic_Form_Internal.hasContextRefContext);
var modify1 = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Vault.semigroupVault);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Loading.monoidLoadingStatus);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Result.applicativeResult);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Restaumatic_Form_Errors.semigroupFormErrors);
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Result.functorResult);
var from = /* #__PURE__ */ Type_Equality.from(Type_Equality.refl);
var $$switch = /* #__PURE__ */ Specular_Extra_Switch["switch"](Specular_Extra_Switch.switchEvent);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Restaumatic_Form_Errors.monoidFormErrors);
var map2 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Errors.semigroupFormErrors));
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Restaumatic_Form_Internal.monadEffectFormDefM);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var when = /* #__PURE__ */ Control_Applicative.when(Effect.applicativeEffect);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(/* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString)));
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(valueIsSymbol);
var touchedIsSymbol = {
    reflectSymbol: function () {
        return "touched";
    }
};
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode);
var readValueIsSymbol = {
    reflectSymbol: function () {
        return "readValue";
    }
};
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode);
var readValidationErrorsIsSymbol = {
    reflectSymbol: function () {
        return "readValidationErrors";
    }
};
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode));
var displayedErrorsIsSymbol = {
    reflectSymbol: function () {
        return "displayedErrors";
    }
};
var defaultValueIsSymbol = {
    reflectSymbol: function () {
        return "defaultValue";
    }
};
var sequenceRecord = /* #__PURE__ */ Record_Extra.sequenceRecord()(/* #__PURE__ */ Record_Extra.sequenceRecordCons(defaultValueIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(displayedErrorsIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(readValidationErrorsIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(readValueIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordCons(touchedIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(valueIsSymbol)()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()());
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
var optionForEq = /* #__PURE__ */ Restaumatic_Form_Internal.optionForEq();
var write1 = /* #__PURE__ */ Specular_Ref.write(Restaumatic_Form_Internal.monadEffectFormDefM);
var read = /* #__PURE__ */ Specular_Ref.read(Effect_Class.monadEffectEffect);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Effect_Class.monadEffectEffect);
var pure5 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Data_Vault.monoidVault);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString));
var join = /* #__PURE__ */ Control_Bind.join(Specular_FRP_Base.bindDynamic);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray)(Restaumatic_Form_Errors.monoidFormErrors);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic);
var annotate = /* #__PURE__ */ Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var pure6 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var discard2 = /* #__PURE__ */ discard(Restaumatic_Form_Internal.bindFormDefM);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Restaumatic_Form_Internal.applicativeFormDefM)(Data_Foldable.foldableMaybe);
var FormField = function (x) {
    return x;
};
var mergeFormField$prime = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        merge: function (x) {
            return function (v) {
                return write(v.value)(new Restaumatic_Form_Internal.Valid({
                    value: to(x),
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        }
    };
};
var merge = /* #__PURE__ */ Restaumatic_Form_Internal.merge(/* #__PURE__ */ mergeFormField$prime(Type_Equality.refl));
var initializeSomeInitialValu = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(Restaumatic_Form_Internal.makeWithInitialValueIniti1(dictInitialize))
    };
};
var initializeNoInitializerFo = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithDefaultInitializer(dictInitialize)({})
    };
};
var initializeNoInitialValueI = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(Restaumatic_Form_Internal.makeWithInitialValueIniti(dictInitialize))
    };
};
var initializeMetadataInitial = function (dictAddMetadata) {
    return function (dictInitialize) {
        return {
            makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictInitialize)(dictAddMetadata)
        };
    };
};
var initializeEffectInitializ = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithEffectInitializer(dictInitialize)
    };
};
var initializeContextInitiali = function (dictAddContext) {
    return function (dictInitialize) {
        return {
            makeImpl: Restaumatic_Form_Internal.makeWithContextInitializer(dictInitialize)(dictAddContext)
        };
    };
};
var initialValueTotalNoInitia = function (dictHasDefaultValue) {
    var defaultValue1 = Restaumatic_Form_HasDefaultValue.defaultValue(dictHasDefaultValue);
    return {
        getInitialValue: function (v) {
            return function (v1) {
                return pure(defaultValue1);
            };
        }
    };
};
var initialValueSomeInitialVa = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        getInitialValue: function (v) {
            return function (v1) {
                return pure(to(v1.value0));
            };
        }
    };
};
var initialValuePartialNoInit = {
    getInitialValue: function (v) {
        return function (v1) {
            return Restaumatic_Form_Value.noValue;
        };
    }
};
var hasContextFormField$prime = {
    getContext: function (v) {
        return getContext(v.context);
    }
};
var dynamicFromContext = /* #__PURE__ */ Restaumatic_Form_Internal.dynamicFromContext(hasContextFormField$prime);
var formFieldLikeFormField$prime = {
    withFormFieldD: function (f) {
        return function (field) {
            return f(field);
        };
    }
};
var addContextFormField$prime = {
    addContext: function (ctx) {
        return function (v) {
            return modify1(v.context)(function (v1) {
                return append(ctx)(v1);
            });
        };
    }
};
var withFormFieldD = function (dict) {
    return dict.withFormFieldD;
};
var formFieldLikeDelayed = function (dictFormFieldLike) {
    var withFormFieldD1 = withFormFieldD(dictFormFieldLike);
    return {
        withFormFieldD: function (f) {
            return function (v) {
                return bind(v)(withFormFieldD1(f));
            };
        }
    };
};
var valueStateToResult = function (name) {
    return function (label) {
        return function (valueState) {
            return function (errors) {
                var value$prime = (function () {
                    if (valueState instanceof Restaumatic_Form_Internal.Undefined) {
                        return new Restaumatic_Form_Result.Result(mempty, Restaumatic_Form_Internal.requiredError(Data_Unit.unit), valueState.value0.lastValid);
                    };
                    if (valueState instanceof Restaumatic_Form_Internal.Valid) {
                        return pure1(valueState.value0.value);
                    };
                    if (valueState instanceof Restaumatic_Form_Internal.Invalid) {
                        return new Restaumatic_Form_Result.Result(mempty, valueState.value0.error, valueState.value0.lastValid);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 168, column 7 - line 174, column 40): " + [ valueState.constructor.name ]);
                })();
                return Restaumatic_Form_Result.mapErrors((function () {
                    var $421 = Restaumatic_Form_Internal.tagErrors(name)(label);
                    return function ($422) {
                        return $421((function (v) {
                            return append1(v)(errors);
                        })($422));
                    };
                })())(map(from)(value$prime));
            };
        };
    };
};
var userEdit = function (dictFormFieldLike) {
    var withFormFieldD1 = withFormFieldD(dictFormFieldLike);
    return function (df) {
        return $$switch(Data_Function.flip(withFormFieldD1)(df)(function (v) {
            return pure2(v.userEdit.event);
        }));
    };
};
var toFormFieldE = function (dictFormFieldLike) {
    var $423 = withFormFieldD(dictFormFieldLike)(pure2);
    return function ($424) {
        return readDynamic($423($424));
    };
};
var touch = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function __do() {
            var v = toFormFieldE1(df)();
            return write(v.touched)(true)();
        };
    };
};
var touch1 = /* #__PURE__ */ touch(formFieldLikeFormField$prime);
var writeValue = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (v) {
            return function __do() {
                var v1 = toFormFieldE1(df)();
                var handler = Effect_Ref.read(v1.onWriteValue)();
                return handler(v1)(v)();
            };
        };
    };
};
var writeValue1 = /* #__PURE__ */ writeValue(formFieldLikeFormField$prime);
var writeValidValue = function (dictMonadEffect) {
    var liftEffect2 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictFormFieldLike) {
        var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
        return function (dfield) {
            return function (value) {
                return liftEffect2(function __do() {
                    var field = toFormFieldE1(dfield)();
                    return writeValue1(field)(new Restaumatic_Form_Internal.Valid({
                        value: value,
                        editValue: Data_Maybe.Nothing.value
                    }))();
                });
            };
        };
    };
};
var writeValidValue1 = /* #__PURE__ */ writeValidValue(Effect_Class.monadEffectEffect)(formFieldLikeFormField$prime);
var readValueState = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return v.readValueState;
    });
};
var readValueState1 = /* #__PURE__ */ readValueState(formFieldLikeFormField$prime);
var isTextFieldFormField$prime = function (dictEditAsString) {
    var parse = Restaumatic_Form_EditAsString.parse(dictEditAsString);
    var toString = Restaumatic_Form_EditAsString.toString(dictEditAsString);
    return {
        textInput: function (field) {
            var parse$prime = function (str) {
                var v = parse(str);
                if (v instanceof Data_Either.Left) {
                    return new Restaumatic_Form_Internal.Invalid({
                        error: Restaumatic_Form_Errors.userVisibleError(v.value0),
                        lastValid: Restaumatic_Form_Value.noValue,
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                if (v instanceof Data_Either.Right) {
                    return new Restaumatic_Form_Internal.Valid({
                        value: v.value0,
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 416, column 7 - line 420, column 47): " + [ v.constructor.name ]);
            };
            return {
                displayedValue: mapFlipped(readValueState1(field))(function (v) {
                    if (v instanceof Restaumatic_Form_Internal.Undefined) {
                        return "";
                    };
                    if (v instanceof Restaumatic_Form_Internal.Invalid) {
                        return Data_Maybe.fromMaybe("")(v.value0.editValue);
                    };
                    if (v instanceof Restaumatic_Form_Internal.Valid && v.value0.editValue instanceof Data_Maybe.Just) {
                        return v.value0.editValue.value0;
                    };
                    if (v instanceof Restaumatic_Form_Internal.Valid && v.value0.editValue instanceof Data_Maybe.Nothing) {
                        return toString(v.value0.value);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 398, column 9 - line 406, column 40): " + [ v.constructor.name ]);
                }),
                onChange: function (str) {
                    return writeValue1(field)(parse$prime(str));
                },
                onTouch: touch1(field),
                placeholder: pure2("")
            };
        }
    };
};
var queryFormField$prime = function (dictTypeEquals) {
    var from1 = Type_Equality.from(dictTypeEquals);
    return {
        queryImpl: function (v) {
            return function (v1) {
                if (v instanceof Restaumatic_Form_Query.Lax) {
                    return Restaumatic_Form_DynamicResult.wrap(apply(map1(function (v2) {
                        return function (v3) {
                            return map(from1)(valueStateToResult(v1.name)(v3)(v2)(mempty1));
                        };
                    })(readValueState1(v1)))(bind(Specular_Ref.value(v1.label))(Restaumatic_Form_Final.unFinal)));
                };
                if (v instanceof Restaumatic_Form_Query.Strict) {
                    return map2(from1)(v1.cachedQuery);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 157, column 1 - line 162, column 75): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
};
var queryImpl = /* #__PURE__ */ Restaumatic_Form_Query.queryImpl(/* #__PURE__ */ queryFormField$prime(Type_Equality.refl));
var readValueF = function (dictFormFieldLike) {
    var readValueState2 = readValueState(dictFormFieldLike);
    return function (field) {
        return Restaumatic_Form_Final.makeFinalV(mapFlipped(readValueState2(field))(function (v) {
            if (v instanceof Restaumatic_Form_Internal.Undefined) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Internal.requiredError(Data_Unit.unit));
            };
            if (v instanceof Restaumatic_Form_Internal.Valid) {
                return pure3(v.value0.value);
            };
            if (v instanceof Restaumatic_Form_Internal.Invalid) {
                return Data_Validation_Semigroup.invalid(v.value0.error);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 181, column 3 - line 187, column 20): " + [ v.constructor.name ]);
        }));
    };
};
var readValueF1 = /* #__PURE__ */ readValueF(formFieldLikeFormField$prime);
var validations = function () {
    return function (v) {
        return function (v1) {
            return liftEffect(write(v1.validations)(map3(function (v2) {
                return v2(readValueF1(v1));
            })(v)));
        };
    };
};
var isCheckboxFieldFormField$prime = function (dictAsCheckboxState) {
    var fromBoolean = Restaumatic_Form_Checkbox.fromBoolean(dictAsCheckboxState);
    var toTristate = Restaumatic_Form_Checkbox.toTristate(dictAsCheckboxState);
    return {
        checkboxInput: function (v) {
            return liftEffect1(function __do() {
                var initial = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                when(Data_Maybe.isNothing(initial))(write(v.value)(new Restaumatic_Form_Internal.Valid({
                    value: fromBoolean(false),
                    editValue: Data_Maybe.Nothing.value
                })))();
                return {
                    displayedValue: map1(Data_Maybe.maybe(Restaumatic_Form_Checkbox.Unchecked.value)(toTristate))(Restaumatic_Form_Final.unFinal(readValueF1(v))),
                    onChange: (function () {
                        var $425 = writeValidValue1(v);
                        return function ($426) {
                            return $425(fromBoolean($426));
                        };
                    })()
                };
            });
        }
    };
};
var isRefLikeFormField$prime = {
    readRefLike: function (f) {
        return Restaumatic_Form_Final.unFinal(readValueF1(f));
    },
    writeRefLike: writeValue1,
    touchRefLike: touch1
};
var writeRefLike = /* #__PURE__ */ Restaumatic_Form_Internal.writeRefLike(isRefLikeFormField$prime);
var mergeInputRequiredFormFie = {
    mergeInputRequired: function (field) {
        return writeRefLike(field)(new Restaumatic_Form_Internal.Invalid({
            error: Restaumatic_Form_Internal.requiredError(Data_Unit.unit),
            lastValid: Restaumatic_Form_Value.noValue,
            editValue: Data_Maybe.Nothing.value
        }));
    }
};
var readValidationErrors = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        var getErrors = (function () {
            var $427 = map3(function (v1) {
                return v1.message;
            });
            var $428 = Data_Array.filter(function ($432) {
                return !(function (v1) {
                    return v1.internal;
                })($432);
            });
            var $429 = Data_Maybe.fromMaybe([  ]);
            var $430 = lookup(new Data_Maybe.Just(v.name));
            return function ($431) {
                return $427($428($429($430(unwrap($431)))));
            };
        })();
        return map1(getErrors)(Restaumatic_Form_DynamicResult.errors(queryImpl(Restaumatic_Form_Query.Strict.value)(v)));
    });
};
var readValidationErrors1 = /* #__PURE__ */ readValidationErrors(formFieldLikeFormField$prime);
var hasErrorsFormField$prime = {
    displayedErrors: function (v) {
        return apply(apply(map1(function (v1) {
            return function (v2) {
                return function (v3) {
                    var $373 = v1 || v2;
                    if ($373) {
                        return v3;
                    };
                    return [  ];
                };
            };
        })(Specular_Ref.value(v.touched)))(map1(Data_Maybe.fromMaybe(false))(dynamicFromContext(Restaumatic_Form_Internal.forceDisplayErrorsKey)(v))))(readValidationErrors1(v));
    }
};
var displayedErrors = /* #__PURE__ */ Restaumatic_Form_Internal.displayedErrors(hasErrorsFormField$prime);
var dumpStateFormField$prime = function (dictEncode) {
    var encodeWithOptionsOther3 = Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(dictEncode));
    var encode1 = Foreign_Generic_Class.encode(dictEncode);
    return function (dictEncode1) {
        var encode2 = Foreign_Generic_Class.encode(recordEncode(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons(encodeRecordCons1(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode1)))(touchedIsSymbol)(encodeWithOptionsOther))(readValueIsSymbol)(encodeWithOptionsOther1))(readValidationErrorsIsSymbol)(encodeWithOptionsOther2))(displayedErrorsIsSymbol)(encodeWithOptionsOther2))(defaultValueIsSymbol)(encodeWithOptionsOther3)));
        return {
            dumpState: function (v) {
                return map1(encode2)(sequenceRecord({
                    value: Specular_Ref.value(v.value),
                    defaultValue: bind(Specular_Ref.value(v.defaultValue))(Restaumatic_Form_Final.unFinal),
                    touched: Specular_Ref.value(v.touched),
                    readValue: map1(Data_Maybe.maybe(encode("(NO READ VALUE)"))(encode1))(Restaumatic_Form_Final.unFinal(readValueF1(v))),
                    readValidationErrors: readValidationErrors1(v),
                    displayedErrors: displayedErrors(v)
                }));
            }
        };
    };
};
var readOptions = function () {
    return function (dictFormFieldLike) {
        return withFormFieldD(dictFormFieldLike)(function (v) {
            return bind(Specular_Ref.value(v.options))(function (optionsDef) {
                return map1(Data_Maybe.maybe([  ])(Data_Leibniz.runLeibniz(optionForEq)))(Restaumatic_Form_Final.unFinal(optionsDef));
            });
        });
    };
};
var readOptions1 = /* #__PURE__ */ readOptions()(formFieldLikeFormField$prime);
var isMultiSelectFieldFormFie = function (dictContainer) {
    var fromArray = Restaumatic_Form_Internal.fromArray(dictContainer);
    var maybeContainerToArray = Restaumatic_Form_Internal.maybeContainerToArray(dictContainer);
    return function () {
        return {
            mSelectWriteValue: function (field) {
                return function (value) {
                    return writeValidValue1(field)(fromArray(value));
                };
            },
            mSelectReadValue: function (field) {
                return map1(maybeContainerToArray)(Restaumatic_Form_Final.unFinal(readValueF1(field)));
            },
            mSelectGetOptions: readOptions1,
            mSelectTouch: touch1
        };
    };
};
var isSelectFieldFormField$prime = function () {
    return {
        selectWriteValue: writeValidValue1,
        selectReadValue: function ($433) {
            return Restaumatic_Form_Final.unFinal(readValueF1($433));
        },
        selectGetOptions: readOptions1,
        selectTouch: touch1
    };
};
var readLabel = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return bind(Specular_Ref.value(v.label))(function (label) {
            return Restaumatic_Form_Final.unFinal(label);
        });
    });
};
var hasLabelFormField$prime = {
    getLabel: /* #__PURE__ */ readLabel(formFieldLikeFormField$prime)
};
var options = function () {
    return function () {
        return function (v) {
            return function (v1) {
                return liftEffect(write(v1.options)(Data_Leibniz.runLeibniz(Data_Leibniz.liftLeibniz(Data_Leibniz.symm(optionForEq)))(v)));
            };
        };
    };
};
var onWriteValue = function () {
    return function (v) {
        return function (v1) {
            return liftEffect(Effect_Ref.write(v)(v1.onWriteValue));
        };
    };
};
var normalize = function () {
    return function (v) {
        return function (v1) {
            return write1(v1.normalize)(v);
        };
    };
};
var modifyValidValue = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (update) {
            return function __do() {
                var v = toFormFieldE1(df)();
                var old = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                writeValidValue1(v)(update(old))();
                touch1(v)();
                return v.userEdit.fire(Data_Unit.unit)();
            };
        };
    };
};
var modify = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (update) {
            return function __do() {
                var v = toFormFieldE1(df)();
                var old = readDynamic(Restaumatic_Form_Final.unFinal(readValueF1(v)))();
                if (old instanceof Data_Maybe.Nothing) {
                    return Data_Unit.unit;
                };
                if (old instanceof Data_Maybe.Just) {
                    writeValidValue1(v)(update(old.value0))();
                    touch1(v)();
                    return v.userEdit.fire(Data_Unit.unit)();
                };
                throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 243, column 3 - line 249, column 27): " + [ old.constructor.name ]);
            };
        };
    };
};
var isTouched = function (dictFormFieldLike) {
    return withFormFieldD(dictFormFieldLike)(function (v) {
        return Specular_Ref.value(v.touched);
    });
};
var getLastValid = function (v) {
    if (v instanceof Restaumatic_Form_Internal.Undefined) {
        return v.value0.lastValid;
    };
    if (v instanceof Restaumatic_Form_Internal.Invalid) {
        return v.value0.lastValid;
    };
    if (v instanceof Restaumatic_Form_Internal.Valid) {
        return pure(v.value0.value);
    };
    throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 233, column 3 - line 236, column 34): " + [ v.constructor.name ]);
};
var getInitialValue = function (dict) {
    return dict.getInitialValue;
};
var fieldNameString = function (v) {
    return Restaumatic_Form_Internal.fieldPathToString(v.name);
};
var hasFieldIdFormField$prime = {
    getFieldId: fieldNameString
};
var defaultValue = function () {
    return function (v) {
        return function (v1) {
            return write1(v1.defaultValue)(v);
        };
    };
};
var copyStateFormField = {
    copyState: function (v) {
        return function (v1) {
            return bind1(read(v.value))(write(v1.value));
        };
    }
};
var augmentWithLastValid = function (v) {
    return function (v1) {
        if (v instanceof Restaumatic_Form_Internal.Undefined) {
            return new Restaumatic_Form_Internal.Undefined({
                lastValid: Restaumatic_Form_Value.orElse(v.value0.lastValid)(getLastValid(v1))
            });
        };
        if (v instanceof Restaumatic_Form_Internal.Invalid) {
            return new Restaumatic_Form_Internal.Invalid({
                error: v.value0.error,
                editValue: v.value0.editValue,
                lastValid: Restaumatic_Form_Value.orElse(v.value0.lastValid)(getLastValid(v1))
            });
        };
        if (v instanceof Restaumatic_Form_Internal.Valid) {
            return new Restaumatic_Form_Internal.Valid(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.FormField (line 226, column 1 - line 226, column 91): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var defaultWriteValue = function (v) {
    return function (v1) {
        return function __do() {
            modify1(v.value)(augmentWithLastValid(v1))();
            write(v.touched)(true)();
            return v.userEdit.fire(Data_Unit.unit)();
        };
    };
};
var unsafeNewEmptyFormField = function (dictIsTotality) {
    var isTotal = Restaumatic_Form_Totality.isTotal(dictIsTotality);
    return function (opts) {
        return function __do() {
            var label_ = $$new(Restaumatic_Form_Final.liftMaybe(Data_Maybe.Nothing.value))();
            var value = $$new(new Restaumatic_Form_Internal.Undefined({
                lastValid: Restaumatic_Form_Value.unsafeNoValue
            }))();
            var defaultValue1 = $$new(Restaumatic_Form_Final.makeFinalV(pure2(Data_Validation_Semigroup.invalid(Restaumatic_Form_Internal.requiredError(Data_Unit.unit)))))();
            var touched = $$new(false)();
            var options1 = $$new(pure5([  ]))();
            var validations1 = $$new([  ])();
            var context = $$new(mempty2)();
            var normalize1 = $$new(pure2(identity))();
            var userEdit1 = newEvent();
            var onWriteValue_ = Effect_Ref["new"](defaultWriteValue)();
            var readValueState_ = Specular_FRP_Base.annotated("FormField.readValueState " + show(opts.name))(apply(apply(map1(function (v) {
                return function (v1) {
                    return function (v2) {
                        if (v2 instanceof Restaumatic_Form_Internal.Undefined) {
                            return Data_Validation_Semigroup.validation(function (e) {
                                return new Restaumatic_Form_Internal.Invalid({
                                    error: append1(Restaumatic_Form_Internal.requiredError(Data_Unit.unit))(e),
                                    lastValid: v2.value0.lastValid,
                                    editValue: Data_Maybe.Nothing.value
                                });
                            })(function (x) {
                                return new Restaumatic_Form_Internal.Valid({
                                    value: x,
                                    editValue: Data_Maybe.Nothing.value
                                });
                            })(v);
                        };
                        if (v2 instanceof Restaumatic_Form_Internal.Valid) {
                            return new Restaumatic_Form_Internal.Valid({
                                value: v1(v2.value0.value),
                                editValue: v2.value0.editValue
                            });
                        };
                        return v2;
                    };
                };
            })(bind(Specular_Ref.value(defaultValue1))(Restaumatic_Form_Final.unFinalV)))(join(Specular_Ref.value(normalize1))))(Specular_Ref.value(value)));
            var extractErrors = function (label) {
                var toErrors = function (v) {
                    if (v.length === 0) {
                        return mempty1;
                    };
                    return wrap(Data_Map_Internal.singleton(new Data_Maybe.Just(opts.name))(mapFlipped1(v)(function (message) {
                        return {
                            fieldName: new Data_Maybe.Just(opts.name),
                            fieldLabel: label,
                            message: message,
                            internal: false
                        };
                    })));
                };
                var extractErrors$prime = Data_Validation_Semigroup.validation(identity)(toErrors);
                return foldMap(extractErrors$prime);
            };
            var cachedQuery = Restaumatic_Form_DynamicResult.wrap(apply(apply(map1(function (v) {
                return function (v1) {
                    return function (v2) {
                        return valueStateToResult(opts.name)(v2)(v1)(extractErrors(v2)(v));
                    };
                };
            })(bind(Specular_Ref.value(validations1))(function (validations$prime) {
                return sequence(map3(Restaumatic_Form_Final.unFinalV)(validations$prime));
            })))(readValueState_))(bind(Specular_Ref.value(label_))(Restaumatic_Form_Final.unFinal)));
            annotate(Specular_Ref.value(value))("FormField.value")();
            annotate(Specular_Ref.value(touched))("FormField.touched")();
            return {
                name: opts.name,
                label: label_,
                value: value,
                defaultValue: defaultValue1,
                touched: touched,
                options: options1,
                validations: validations1,
                context: context,
                normalize: normalize1,
                userEdit: userEdit1,
                readValueState: readValueState_,
                onWriteValue: onWriteValue_,
                isTotal: isTotal(Type_Proxy["Proxy"].value),
                cachedQuery: cachedQuery
            };
        };
    };
};
var makeEmptyFormField$primePartia = {
    makeEmptyImpl: /* #__PURE__ */ unsafeNewEmptyFormField(Restaumatic_Form_Totality.isTotalityPartial)
};
var initializeRecordFormField = function (dictFromDefaults) {
    var fromDefaults = Data_NamedParams.fromDefaults(dictFromDefaults);
    return function (dictIsTotality) {
        var unsafeNewEmptyFormField1 = unsafeNewEmptyFormField(dictIsTotality);
        return function () {
            return function (dictInitialValue) {
                var getInitialValue1 = getInitialValue(dictInitialValue);
                return {
                    makeImpl: function (v) {
                        return function (opts) {
                            return bind2(liftEffect1(unsafeNewEmptyFormField1(opts)))(function (v1) {
                                return pure6({
                                    field: v1,
                                    init: function (iv) {
                                        return function (initializer) {
                                            var params = fromDefaults({
                                                defaultValue: Restaumatic_Form_Final.makeFinalV(pure2(Data_Validation_Semigroup.invalid(Restaumatic_Form_Internal.requiredError(Data_Unit.unit)))),
                                                normalize: pure2(identity),
                                                onWriteValue: defaultWriteValue,
                                                options: pure5([  ]),
                                                validations: [  ],
                                                label: Restaumatic_Form_Final.liftMaybe(Data_Maybe.Nothing.value)
                                            })(initializer);
                                            return discard2(for_(Restaumatic_Form_Value.toMaybe(getInitialValue1(Type_Proxy["Proxy"].value)(iv)))(function (x) {
                                                return liftEffect(merge(x)(v1));
                                            }))(function () {
                                                return discard2(write1(v1.defaultValue)(params.defaultValue))(function () {
                                                    return discard2(write1(v1.normalize)(params.normalize))(function () {
                                                        return discard2(write1(v1.options)(Data_Leibniz.runLeibniz(Data_Leibniz.liftLeibniz(Data_Leibniz.symm(optionForEq)))(params.options)))(function () {
                                                            return discard2(write1(v1.validations)(map3(function (v2) {
                                                                return v2(readValueF1(v1));
                                                            })(params.validations)))(function () {
                                                                return write1(v1.label)(params.label);
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        };
                                    }
                                });
                            });
                        };
                    }
                };
            };
        };
    };
};
var writeValueNoTouch = function (dictFormFieldLike) {
    var toFormFieldE1 = toFormFieldE(dictFormFieldLike);
    return function (df) {
        return function (v) {
            return function __do() {
                var v1 = toFormFieldE1(df)();
                modify1(v1.value)(augmentWithLastValid(v))();
                return v1.userEdit.fire(Data_Unit.unit)();
            };
        };
    };
};
export {
    getInitialValue,
    withFormFieldD,
    FormField,
    unsafeNewEmptyFormField,
    toFormFieldE,
    valueStateToResult,
    readValueF,
    readValueState,
    fieldNameString,
    writeValidValue,
    writeValue,
    defaultWriteValue,
    writeValueNoTouch,
    augmentWithLastValid,
    getLastValid,
    modify,
    modifyValidValue,
    touch,
    readOptions,
    readLabel,
    readValidationErrors,
    isTouched,
    userEdit,
    defaultValue,
    normalize,
    onWriteValue,
    options,
    validations,
    formFieldLikeFormField$prime,
    formFieldLikeDelayed,
    queryFormField$prime,
    hasErrorsFormField$prime,
    dumpStateFormField$prime,
    initializeRecordFormField,
    makeEmptyFormField$primePartia,
    mergeFormField$prime,
    mergeInputRequiredFormFie,
    addContextFormField$prime,
    initialValuePartialNoInit,
    initialValueTotalNoInitia,
    initialValueSomeInitialVa,
    isTextFieldFormField$prime,
    hasLabelFormField$prime,
    isSelectFieldFormField$prime,
    isMultiSelectFieldFormFie,
    isRefLikeFormField$prime,
    isCheckboxFieldFormField$prime,
    copyStateFormField,
    hasFieldIdFormField$prime,
    hasContextFormField$prime,
    initializeNoInitialValueI,
    initializeSomeInitialValu,
    initializeContextInitiali,
    initializeMetadataInitial,
    initializeEffectInitializ,
    initializeNoInitializerFo
};
